import $ from "jquery";

function parsePercentPair(value) {
	if (!value || String(value).trim() === "") {
		return { x: "50%", y: "50%" };
	}
	const parts = String(value).trim().split(/\s+/);
	return {
		x: parts[0] || "50%",
		y: parts[1] || "50%"
	};
}

function isCenter(value) {
	return !value || String(value).trim() === "" || String(value).trim() === "50% 50%";
}

function positionKey(x, y) {
	return `${x} ${y}`;
}

function initImageFocusPoint($root) {
	const labelSet = $root.data("labelSet") || "Set";
	const labelChange = $root.data("labelChange") || "Change";
	const $hidden = $root.find(".gc-ifp__position-input");
	const $overlay = $root.find(".gc-ifp__overlay");
	const $img = $root.find(".gc-ifp__image");
	const $pin = $root.find(".gc-ifp__pin");
	const $open = $root.find(".gc-ifp__open");
	const $reset = $root.find(".gc-ifp__reset");
	const $save = $root.find(".gc-ifp__save");
	const $cancel = $root.find(".gc-ifp__cancel");
	const $valueCoords = $root.find(".gc-ifp__value-coords");
	const $valueCenter = $root.find(".gc-ifp__value-center");
	let x = "50%";
	let y = "50%";

	function readFromInput() {
		const v = $hidden.val();
		const parsed = parsePercentPair(v);
		x = parsed.x;
		y = parsed.y;
	}

	function applyPin() {
		$pin.css({ left: x, top: y });
	}

	function syncValueDisplay() {
		const v = $hidden.val();
		if (isCenter(v)) {
			$valueCoords.attr("hidden", true).text("");
			$valueCenter.removeAttr("hidden");
			$open.text(labelSet);
			$reset.attr("hidden", true);
		} else {
			$valueCoords.removeAttr("hidden").text(v);
			$valueCenter.attr("hidden", true);
			$open.text(labelChange);
			$reset.removeAttr("hidden");
		}
	}

	function syncSaveEnabled() {
		const input = $hidden.val();
		const changed = positionKey(x, y) !== String(input || "").trim();
		$save.prop("disabled", !changed);
		if (changed) {
			$save.addClass("gc-ifp__save--enabled");
		} else {
			$save.removeClass("gc-ifp__save--enabled");
		}
	}

	function openOverlay() {
		readFromInput();
		const parsed = parsePercentPair($hidden.val());
		x = parsed.x;
		y = parsed.y;
		applyPin();
		$overlay.addClass("gc-ifp__overlay--open");
		syncSaveEnabled();
	}

	function closeOverlay() {
		$overlay.removeClass("gc-ifp__overlay--open");
	}

	function closeAndSave() {
		$hidden.val(positionKey(x, y));
		$hidden[0].dispatchEvent(new Event("change", { bubbles: true }));
		syncValueDisplay();
		closeOverlay();
	}

	readFromInput();
	applyPin();
	syncValueDisplay();

	$open.on("click", () => openOverlay());

	$cancel.on("click", () => {
		x = "50%";
		y = "50%";
		applyPin();
		closeOverlay();
	});

	$save.on("click", () => closeAndSave());

	$reset.on("click", () => {
		x = "50%";
		y = "50%";
		applyPin();
		closeAndSave();
	});

	$img.on("click", (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const relX = e.clientX - rect.left;
		const relY = e.clientY - rect.top;
		const w = e.currentTarget.clientWidth;
		const h = e.currentTarget.clientHeight;
		x = Math.round((relX / w) * 100) + "%";
		y = Math.round((relY / h) * 100) + "%";
		applyPin();
		syncSaveEnabled();
	});

	$overlay.on("click", (e) => {
		if (e.target === $overlay[0]) {
			$cancel.trigger("click");
		}
	});
}

function scanAndInit() {
	$(".gc-ifp").each(function () {
		const $el = $(this);
		if ($el.data("gcIfpInit")) {
			return;
		}
		$el.data("gcIfpInit", true);
		initImageFocusPoint($el);
	});
}

let scanScheduled = false;
function scheduleScanAndInit() {
	if (scanScheduled) {
		return;
	}
	scanScheduled = true;
	requestAnimationFrame(function () {
		scanScheduled = false;
		scanAndInit();
	});
}

$(function () {
	scanAndInit();

	if (typeof MutationObserver !== "undefined" && document.body) {
		new MutationObserver(function () {
			scheduleScanAndInit();
		}).observe(document.body, { childList: true, subtree: true });
	}
});

$(document).ajaxComplete(function (_e, _xhr, settings) {
	if (settings && settings.url && settings.url.indexOf("async-upload.php") !== -1) {
		scheduleScanAndInit();
	}
});
